import {createTheme} from '@mui/material';

import {C} from './contentGenerator/constants';

export const THEME_VARS = {
    light: {
        '--cg-canvas': '#f4f1ea',
        '--cg-surface': '#ffffff',
        '--cg-surface-alt': '#faf8f2',
        '--cg-surface-raised': '#f7f5f0',
        '--cg-mist': '#f7f5f0',
        '--cg-text': '#1a1814',
        '--cg-text-muted': '#8d877f',
        '--cg-text-soft': '#b2ada5',
        '--cg-text-faint': '#c9c4bc',
        '--cg-border': 'rgba(0,0,0,.09)',
        '--cg-border-strong': 'rgba(0,0,0,.15)',
        '--cg-shadow': '0 16px 30px rgba(26,24,20,.12)',
    },
    dark: {
        '--cg-canvas': '#121714',
        '--cg-surface': '#1a211d',
        '--cg-surface-alt': '#202924',
        '--cg-surface-raised': '#28322c',
        '--cg-mist': '#161d19',
        '--cg-text': '#f3ede4',
        '--cg-text-muted': '#d1cabd',
        '--cg-text-soft': '#b3ab9f',
        '--cg-text-faint': '#938b7f',
        '--cg-border': 'rgba(255,255,255,.16)',
        '--cg-border-strong': 'rgba(255,255,255,.28)',
        '--cg-shadow': '0 18px 34px rgba(0,0,0,.42)',
    },
};

export const getThemeVars = (theme = 'light') => THEME_VARS[theme] || THEME_VARS.light;

export const applyThemeVars = (theme = 'light') => {
    if (typeof document === 'undefined') return;

    const themeVars = getThemeVars(theme);
    Object.entries(themeVars).forEach(([key, value]) => {
        document.documentElement.style.setProperty(key, value);
    });
    document.documentElement.style.colorScheme = theme === 'dark' ? 'dark' : 'light';
    document.body.style.backgroundColor = themeVars['--cg-canvas'];
    document.body.style.color = themeVars['--cg-text'];
    document.body.style.colorScheme = theme === 'dark' ? 'dark' : 'light';
};

export const createAppTheme = (theme = 'light') => {
    const themeVars = getThemeVars(theme);

    return createTheme({
        palette: {
            mode: theme === 'dark' ? 'dark' : 'light',
            primary: {main: C.teal},
            secondary: {main: C.blue},
            background: {
                default: themeVars['--cg-canvas'],
                paper: themeVars['--cg-surface'],
            },
            text: {
                primary: themeVars['--cg-text'],
                secondary: themeVars['--cg-text-muted'],
            },
            divider: themeVars['--cg-border'],
        },
        shape: {
            borderRadius: 12,
        },
        typography: {
            fontFamily: "'DM Sans',system-ui,sans-serif",
            button: {
                textTransform: 'none',
                fontWeight: 600,
            },
        },
        components: {
            MuiCssBaseline: {
                styleOverrides: {
                    body: {
                        backgroundColor: themeVars['--cg-canvas'],
                        color: themeVars['--cg-text'],
                    },
                },
            },
            MuiPaper: {
                styleOverrides: {
                    root: {
                        backgroundImage: 'none',
                    },
                },
            },
            MuiButtonBase: {
                defaultProps: {
                    disableRipple: true,
                },
            },
            MuiCard: {
                styleOverrides: {
                    root: {
                        backgroundImage: 'none',
                    },
                },
            },
        },
    });
};
